import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LineItemsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "LineItems",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M24 29.71H8c-1.89 0-3.43-1.54-3.43-3.43V5.71a1.14 1.14 0 1 1 2.28 0v20.57c0 .63.51 1.14 1.14 1.14h16c.63 0 1.14-.51 1.14-1.14V5.71a1.14 1.14 0 1 1 2.28 0v20.57c0 1.89-1.54 3.43-3.43 3.43Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21.71 9.14H10.28c-.63 0-1.14-.51-1.14-1.14V3.43c0-.63.51-1.14 1.14-1.14h11.43c.63 0 1.14.51 1.14 1.14V8c0 .63-.51 1.14-1.14 1.14M11.43 6.86h9.14V4.58h-9.14zM21.71 24H10.28a1.14 1.14 0 1 1 0-2.28h11.43a1.14 1.14 0 1 1 0 2.28M21.71 19.43H10.28a1.14 1.14 0 1 1 0-2.28h11.43a1.14 1.14 0 1 1 0 2.28M21.71 14.86H10.28a1.14 1.14 0 1 1 0-2.28h11.43a1.14 1.14 0 1 1 0 2.28"
    })]
  }));
};